export const ADMIN_JOB_CV_REJECTION_REASONS = {
    GENERAL_MISMATCH: 'general_mismatch',
    ROLE_DOMAIN_MISMATCH: 'role_domain_mismatch',
    EXPERIENCE_MISMATCH: 'experience_mismatch',
    SKILLS_MISMATCH: 'skills_mismatch',
    EDUCATION_MISMATCH: 'education_mismatch',
    LANGUAGE_MISMATCH: 'language_mismatch',
    LOCATION_MISMATCH: 'location_mismatch',
    WORK_CONDITIONS_MISMATCH: 'work_conditions_mismatch',
    INSUFFICIENT_DATA: 'insufficient_data',
} as const;

export type AdminJobCvRejectionReason = typeof ADMIN_JOB_CV_REJECTION_REASONS[
    keyof typeof ADMIN_JOB_CV_REJECTION_REASONS
];

const reasonCodes = new Set<string>(Object.values(ADMIN_JOB_CV_REJECTION_REASONS));

export const isAdminJobCvRejectionReason = (
    value: unknown,
): value is AdminJobCvRejectionReason => typeof value === 'string' && reasonCodes.has(value);

export const ADMIN_AI_MATCH_REJECTION_FILTERS = {
    NOT_REJECTED: 'not_rejected',
    REJECTED: 'rejected',
    ALL: 'all',
} as const;

export type AdminAiMatchRejectionFilter = typeof ADMIN_AI_MATCH_REJECTION_FILTERS[
    keyof typeof ADMIN_AI_MATCH_REJECTION_FILTERS
];
